import MessageBox from './src/main.js';
export default MessageBox;



// WEBPACK FOOTER //
// ./packages/message-box/index.js